import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsBySportId = QueryFactory(SD.QueryTypes.GetEventsBySportId);
//# sourceMappingURL=QGetEventsBySportId.js.map